import React, { FC } from 'react';

import { SocialLinkTypes } from '@lglp/prismic-client';
import { useTranslation } from 'react-i18next';

import { SOCIAL } from 'translations';

import { withTrackingEvent } from '../../../../components/mixins/seo';
import { LinkWeb } from '../../../../types';
import {
  FacebookIcon,
  InstagramIcon,
  LinkedInIcon,
  TwitterIcon,
  YoutubeIcon,
} from '../../../Icons';
import { LinkedComponent } from '../../../LinkedComponent';
import styles from './SocialLink.module.scss';

const socialLinkIcons = {
  Facebook: FacebookIcon,
  Instagram: InstagramIcon,
  LinkedIn: LinkedInIcon,
  Twitter: TwitterIcon,
  Youtube: YoutubeIcon,
};

const SocialLinkComponent: FC<SocialLinkComponentProps> = ({
  type,
  link,
  track,
}) => {
  const SocialLinkIcon = socialLinkIcons[type];
  const { t } = useTranslation();

  return (
    <LinkedComponent
      link={link}
      title={t(SOCIAL.SN_ACCESS_TO, { sn: type })}
      onClick={track({
        categoryGA: 'Social',
        actionGA: 'SocialNetworkAccess',
        labelGA: type,
      })}
      className={styles.socialLink}
    >
      <SocialLinkIcon className={styles.socialLinkSvg} />
    </LinkedComponent>
  );
};

type SocialLinkComponentProps = {
  type: SocialLinkTypes;
  link: LinkWeb;
  track: ((arg: any) => any) | (() => null);
};

export const SocialLink = withTrackingEvent(SocialLinkComponent);
